import { fetchApi } from "../components/FetchApi";
import { wrapServiceCall } from "./ServiceUtils";

export const getAllGroups = () =>
  wrapServiceCall(() => fetchApi("/admin/settings/groups", { method: "GET" }));

export const getSettingsByGroup = (group) =>
  wrapServiceCall(() =>
    fetchApi(`/admin/settings/group/${group}`, { method: "GET" })
  );

export const getSettingsMapByGroup = (group) =>
  wrapServiceCall(() =>
    fetchApi(`/admin/settings/group/${group}/map`, { method: "GET" })
  );

export const getSetting = (group, key) =>
  wrapServiceCall(() =>
    fetchApi(`/admin/settings/group/${group}/key/${key}`, { method: "GET" })
  );

export const saveSetting = (setting) =>
  wrapServiceCall(() =>
    fetchApi("/admin/settings", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(setting)
    })
  );

export const saveSettings = (settings, group) =>
  wrapServiceCall(() =>
    fetchApi(`/admin/settings/group/${group}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(settings)
    })
  );

export const deleteSetting = (group, key) =>
  wrapServiceCall(() =>
    fetchApi(`/admin/settings/group/${group}/key/${key}`, { method: "DELETE" })
  );

export const getPublicSettings = () =>
  wrapServiceCall(() => fetchApi("/admin/settings/public", { method: "GET" }));
